<h2 mat-dialog-title>
  Conditions Générales d'Utilisation (CGU) du site {{subdomain}}:
</h2>
<mat-dialog-content class="mat-typography">
  <h3>Dernière mise à jour : 12 octobre 2024</h3>
  <p>
    Les présentes conditions générales d'utilisation (ci-après les « CGU ») ont
    pour objet de définir les conditions dans lesquelles les utilisateurs
    (ci-après les « Utilisateurs ») peuvent accéder et utiliser les services
    proposés par le site internet {{subdomain}} (ci-après le « Site »), ainsi
    que par les guichets et bornes automatiques de commande (ci-après les «
    Bornes »).
  </p>
  <p>
    En accédant au Site ou en utilisant les services de {{subdomain}},
    l'Utilisateur accepte sans réserve les présentes CGU.
  </p>
  <h3>1. Présentation de {{subdomain}}</h3>
  <p>
    {{subdomain}} est un service de commande de taxis, exclusivement pour des
    trajets depuis et vers les aéroports du Maroc. Les réservations peuvent être
    effectuées via le Site, directement à un guichet, ou par le biais de bornes
    automatiques installées dans les aéroports et autres points stratégiques.
  </p>

  <h3>2. Utilisation des services</h3>
  <p>
    Les services proposés par {{subdomain}} sont exclusivement dédiés à la
    commande de taxis pour des trajets entre un aéroport marocain et une autre
    destination au sein du pays. Les trajets entre des points autres que les
    aéroports ne sont pas pris en charge par le service {{subdomain}}. Les
    commandes peuvent être passées : - En ligne, via le site {{subdomain}} ; -
    Directement à un guichet {{subdomain}} ; - Par le biais des bornes
    automatiques {{subdomain}} disponibles dans les aéroports.
  </p>

  <h3>3. Commandes de taxi</h3>
  <h3>3.1. Nature des Prestations</h3>
  <h3>3.1.1. Prestations immédiates</h3>
  <h3>3.1.1.1. Commandes via guichets ou bornes</h3>
  <p>
    Le Client se rend soit à un Guichet soit à une Borne dédiée aux aéroports
    afin d’acheter un ticket lui permettant de réserver un taxi. Le Client doit
    signaler les particularités de la course, telles que l’adresse précise, le
    nombre de passagers, les bagages et les objets spéciaux (fauteuil roulant,
    poussette, vélo, planche de surf, instrument de musique, etc.). Le montant
    de la Course, toutes taxes et charges comprises, est alors indiqué au
    Client. Dès que la Prestation est réglée en espèces ou par Carte Bancaire,
    la Société procède immédiatement à la recherche d'un véhicule et remet sans
    délai au Client un Ticket de réservation indiquant le numéro du taxi qui lui
    est réservé (ci-après dénommé « Ticket de réservation »). Le Client doit
    vérifier les informations indiquées sur le Ticket de réservation. À défaut
    de signalement d’erreurs, le Client est réputé avoir pris connaissance des
    informations et confirmé leur exactitude sans réserve ni restriction. La
    Société ne saurait être tenue responsable pour une erreur non signalée au
    Guichet après le départ du Client.
  </p>

  <h3>3.1.1.2. Commandes via le site et applications mobiles</h3>
  <p>
    Le Client peut également réserver une Course via internet sur le site
    {{subdomain}}, ou via les applications mobiles dédiées pour smartphones
    iPhone® et Android®. Le Client doit signaler les particularités de la
    course, telles que l’aéroport de départ, le nombre de passagers, les bagages
    et les objets spéciaux. Le montant de la Course, toutes taxes et charges
    comprises, est alors indiqué au Client. Une fois la Prestation réglée par
    Carte Bancaire sur le site ou l’application, le Client doit se diriger vers
    un Guichet ou une Borne afin d’imprimer son Ticket de réservation. La
    Société procède immédiatement à la recherche d'un véhicule et envoie sans
    délai au Client un accusé réception indiquant le numéro du taxi qui lui est
    réservé ainsi que son numéro de téléphone.
  </p>

  <h3>3.1.2. Prestations à l'avance</h3>
  <h3>3.1.2.1. Enregistrement à l'avance</h3>
  <p>
    Une Prestation à l'avance consiste en l'enregistrement par la Société d'une
    demande de taxi passée par le Client dans un délai de trente jours maximum à
    60 minutes minimum avant l'heure du déplacement. Il ne s'agit pas de la
    réservation d'un taxi identifié, mais de la prise en compte d'une recherche
    de taxi programmée par la Société pour être effectuée 15 à 45 minutes avant
    l'heure prévue du départ, en fonction du lieu de prise en charge, des
    caractéristiques du taxi demandé et des conditions de circulation attendues.
    La Société se réserve la possibilité de refuser les demandes à l'avance
    certains jours, à certaines heures, en fonction du nombre de demandes déjà
    enregistrées et/ou de l'estimation prévisible concernant l'offre de taxis.
  </p>

  <h3>3.1.2.2. Disponibilité des taxis</h3>

  <p>
    En cas de difficultés pour trouver un taxi disponible, notamment en raison
    de conditions de circulation dégradées ou d’événements perturbant fortement
    la mobilité ou la disponibilité des taxis, la Société se réserve la
    possibilité de contacter le Client trois minutes avant l’heure de départ
    prévue, pour l’informer de l’état d’avancement des recherches et prendre ses
    instructions en vue de la poursuite de la recherche d’un taxi. Le Client
    reconnaît être informé que la Société met en œuvre ses meilleurs efforts
    afin de trouver un taxi disponible à l’heure prévue, mais n’est tenue qu’à
    une obligation de moyens. La Société ne saurait être tenue responsable en
    cas d’indisponibilité de taxi.
  </p>

  <h3>4. Hébergement et maintenance du site</h3>

  <p>
    Le site {{subdomain}} est hébergé au Maroc par la société Genious
    Communications, conformément à la législation en vigueur au Maroc. Le site
    est édité et maintenu par la société Tripass, responsable de sa gestion et de
    son bon fonctionnement.
  </p>

  <h3>5. Moyens de paiement</h3>

  <p>
    {{subdomain}} accepte deux moyens de paiement pour la commande de ses
    services : - Le paiement par carte bancaire (Visa, Mastercard, etc.) ; - Le
    paiement en espèces (cash), uniquement aux guichets ou lors de la prise en
    charge en taxi. Les transactions en ligne via le Site se font exclusivement
    par carte bancaire. Les tarifs des courses sont affichés de manière claire
    avant toute confirmation de commande.
  </p>

  <h3>6. Annulation de commande</h3>
  <h3>6.1. Annulation d'une commande vers l'aéroport</h3>
  <p>
    L'Utilisateur peut annuler une commande de départ vers un aéroport jusqu'à
    30 minutes avant l'heure prévue de prise en charge pour obtenir un
    remboursement intégral. Passé ce délai, l'annulation n'est plus
    remboursable.
  </p>

  <h3>6.2. Annulation d'une commande depuis l'aéroport</h3>
  <p>
    Pour une commande de taxi depuis un aéroport, l'Utilisateur a la possibilité
    d'annuler jusqu'à 24 heures après la commande. En cas d'annulation dans ce
    délai, le montant de la commande sera remboursé, déduction faite des frais
    de service de {{subdomain}}.
  </p>

  <h3>7. Obligations des Utilisateurs</h3>
  <p>
    L'Utilisateur s'engage à fournir des informations exactes lors de la
    commande, que ce soit via le Site, un guichet ou une borne automatique. Tout
    manquement à cette obligation pourra entraîner l'annulation de la commande.
    L'Utilisateur est également tenu de respecter les lois en vigueur au Maroc,
    ainsi que les règles et politiques de {{subdomain}} lors de l'utilisation de
    ses services.
  </p>

  <h3>8. Responsabilité de {{subdomain}}</h3>
  <p>
    {{subdomain}} s'engage à fournir un service de qualité mais ne saurait être
    tenu responsable des retards ou annulations de courses résultant de
    circonstances indépendantes de sa volonté, telles que des conditions de
    circulation, des grèves, ou des conditions météorologiques. En outre,
    {{subdomain}} décline toute responsabilité en cas de perte ou de vol
    d'effets personnels à bord des taxis commandés via ses services.
  </p>

  <h3>9. Propriété intellectuelle</h3>
  <p>
    En application du code de la propriété intellectuelle, tous les éléments du
    site {{subdomain}} ou des applications associées (graphismes, images,
    textes, logos, bases de données, programmes) sont la propriété pleine et
    entière de la Société {{subdomain}}, à l’exception des éléments (logos
    notamment) fournis par les partenaires de la Société. Toute reproduction
    totale ou partielle, modification ou utilisation de marques, illustrations,
    images, éléments et logos, pour quelque motif et sur quelque support que ce
    soit, sans l’accord express et préalable de la Société, est strictement
    interdite. Ainsi, le CLIENT s’interdit expressément d’utiliser, de
    reproduire, d’adapter, de modifier, de créer des œuvres dérivées, de
    distribuer, de vendre, de transférer, de présenter publiquement, de
    transmettre, de diffuser, de référencer, d’indexer, de comparer, d’extraire,
    d’intégrer ou d’exploiter de toute autre manière le service de réservation
    de taxis de la Société, les applications {{subdomain}}, le site internet
    {{subdomain}} et l’intégralité des éléments qui les composent, sauf
    autorisation écrite préalable de la Société.
  </p>

  <h3>10. Protection des données personnelles</h3>
  <p>
    {{subdomain}} accorde une importance primordiale à la protection des données
    personnelles de ses Utilisateurs. Les informations collectées lors des
    commandes sont traitées conformément à la législation en vigueur sur la
    protection des données personnelles au Maroc. Pour plus d’informations,
    veuillez consulter notre Politique de confidentialité.
  </p>

  <h3>11. Utilisation des cookies</h3>
  <p>
    Le site {{subdomain}} utilise des cookies pour améliorer l'expérience de
    navigation des Utilisateurs et proposer des services personnalisés.
  </p>
</mat-dialog-content>

<mat-dialog-actions >
  <!-- <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button> -->
  <button mat-button color="primary" (click)="close()" cdkFocusInitial>
    Close
  </button>
</mat-dialog-actions>
